import {
  type ProductDetailsStick,
  type ProductDetailsStickMixAndMatch,
  type ProductDetailsSticksData,
} from "@jti/fe-common";

import type { ColorVariant } from "../../ProductPerks.types";

const getColorVariants = (sticks: ProductDetailsStick[] | ProductDetailsStickMixAndMatch[]) =>
  sticks.reduce((colorVariants: ColorVariant[], { swatch_data, flavour_label }) => {
    if (!swatch_data || !flavour_label) {
      return colorVariants;
    }

    colorVariants.push({ value: swatch_data, label: flavour_label });

    return colorVariants;
  }, []);

export const getSticksMatrixColorVariants = (sticksData: ProductDetailsSticksData, productSku: string) =>
  Object.values(sticksData).reduce((colorVariants: ColorVariant[], { onetime, subscription }) => {
    if (onetime.find(({ sku }) => sku === productSku)) {
      return getColorVariants(onetime);
    }

    if (subscription.find(({ sku }) => sku === productSku)) {
      return getColorVariants(subscription);
    }

    return colorVariants;
  }, []);
